import { AsyncPipe } from "@angular/common";
import { Component, OnDestroy, ViewChild, inject } from "@angular/core";
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from "@angular/router";
import { UserContext } from "@app/contexts";
import { AlertService } from "@app/services";

import { NavBarComponent, NavBarItemComponent } from "@app/shared/components/navbar";
import { NoticeBoardComponent } from "@app/shared/components/notice-board/notice-board.component";
import { LoadingIndicatorComponent } from "@app/shared/components/ui/loading-indicator";
import { UserMenuComponent, UserMenuItemComponent } from "@app/shared/components/user-menu";
import { Subscription } from "rxjs";
import { SweetAlertResult } from "sweetalert2";

@Component({
  selector: 'lpcr-app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  imports: [
    AsyncPipe,
    RouterOutlet,
    LoadingIndicatorComponent,
    NavBarComponent,
    NavBarItemComponent,
    UserMenuComponent,
    UserMenuItemComponent,
    NoticeBoardComponent

  ]
})
export class MainLayoutComponent implements OnDestroy {

  @ViewChild('noticeBoard')
  public readonly noticeBoard!: NoticeBoardComponent;

  public readonly userContext = inject(UserContext);
  private readonly alertService = inject(AlertService);
  private readonly router = inject(Router);
  private readonly routerSubscription: Subscription = this.router.events.subscribe((event) => {
    if (event instanceof NavigationStart) {
      this.isLoading = true;
    }
    if (event instanceof NavigationEnd) {
      this.isLoading = false;
      if (this.userContext.isConnected && this.userContext.user?.isNoticeBoardToBeShown) {
        this.showNoticeBoardIfNoticesToShow();
        this.userContext.setUser({
          isNoticeBoardToBeShown: false
        });
      }
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.isLoading = false;
    }
    if (event instanceof NavigationError) {
      this.isLoading = false;
    }
  });

  public isLoading: boolean = false;

  public ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  public async logout(): Promise<void> {
    const result: SweetAlertResult = await this.alertService.displayQuestion('Se déconnecter', 'Êtes vous sûrs de vouloir vous déconnecter ?', {
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non, rester connecter'
    });

    if (result && result.isConfirmed) {
      this.router.navigate(['/']);
      window.location.reload();
      this.userContext.logout();
    }
  }

  public forceShowNoticeBoard() {
    this.noticeBoard.launch({ onlyIfNoticesToShow: false });
  }

  public showNoticeBoardIfNoticesToShow() {
    this.noticeBoard.launch({ onlyIfNoticesToShow: true });
  }
}
